import React from 'react';
import { IFormItem } from '../RegistrationFormTypes';
import { RegistrationFormItems } from '../RegistrationFormItems';
import { Translate } from '@above-the-treeline/localization';

type ForgotPasswordFormProps = {
	getFormItem: (item: IFormItem, substituteLabel?: JSX.Element) => void;
};

export default function ForgotPasswordForm({
	getFormItem,
}: ForgotPasswordFormProps) {
	return (
		<>
			<div className="password-reset-label">
				<Translate id="please_enter_your_email_and_click_submit" />
			</div>
			{getFormItem(RegistrationFormItems.Email)}
		</>
	);
}
